import Repository from './Repository';
import {AxiosResponse} from "axios";
import {DonViCreate} from "@/models/donViCreate";
import {BaoCaoCoSoLaoDong} from "@/models/baoCaoCoSoLaoDong";
import {BaoCaoYTeLaoDongTuyenHuyen} from "@/models/baoCaoYTeLaoDongTuyenHuyen";
import baoCaoHoatDongYTeTuyenHuyen from "@/pages/BaoCaoHoatDongYTeTuyenHuyen.vue";
import BaoCaoHoatDongYTeKiemDichThang from "@/pages/BaoCaoHoatDongYTeKiemDichThang.vue";
import {BaoCaoKetQuaHoatDongYTKDThang} from "@/models/baoCaoKetQuaHoatDongYTKDThang";
import {BaoCaoKetQuaHoatDongYTKD6Thang} from "@/models/baoCaoKetQuaHoatDongYTKD6Thang";
import {BaoCaoKetQuaHoatDongYTKDTuan} from "@/models/baoCaoKetQuaHoatDongYTKDTuan";
import baoCaoCongTacYTeTruongHoc from "@/pages/BaoCaoCongTacYTeTruongHoc.vue";
import {BaoCaoYTeTruongHoc} from "@/models/baoCaoYTeTruongHoc";
import {BaoCaoVeSinhNuocSach} from "@/models/baoCaoVeSinhNuocSach";
import baoCaoThongKeTiemVacxin from "@/pages/BaoCaoThongKeTiemVacxin.vue";
import {BaoCaoThongKeTiemVacxin} from "@/models/baoCaoThongKeTiemVacxin";
import baoCaoThongKeTinhHinhSDVacxin from "@/pages/BaoCaoThongKeTinhHinhSDVacxin.vue";
import {BaoCaoTinhHinhSDVacxinVaDCTC} from "@/models/baoCaoTinhHinhSDVacxinVaDCTC";
import {BaoCaoSangLocBenhKLN} from "@/models/baoCaoSangLocBenhKLN";
import {BaoCaoKetQuaHoatDongYTKDNam} from "@/models/baoCaoKetQuaHoatDongYTKDNam";
import {BaoCaoKetQuaHoatDongYTKDNgay} from "@/models/baoCaoKetQuaHoatDongYTKDNgay";
import {ThoiGian} from "@/models/thoiGian";
import baoCaoSanLocBenhKLNVaKSK from "@/pages/BaoCaoSanLocBenhKLNVaKSK.vue";
import {DanhSachBaoCaoThang} from "@/models/danhSachBaoCaoThang";

const resource = '/cdc';

export default new class{
    createDonVi(donVi: DonViCreate): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createDonVi`,donVi);
    }
    getListDonVi(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListDonVi`);
    }
    updateDonVi(donVi: DonViCreate): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateDonVi`,donVi);
    }
    getDonViById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getDonViById/${id}`);
    }
    createBaoCaoYTeLaoDong(baoCaoCoSoLaoDong: BaoCaoCoSoLaoDong): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoYTeLaoDong`,baoCaoCoSoLaoDong);
    }
    updateBaoCaoYTeLaoDong(baoCaoCoSoLaoDong: BaoCaoCoSoLaoDong): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateBaoCaoYTeLaoDong`,baoCaoCoSoLaoDong);
    }
    getUserInfo(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getUserInfo`);
    }
    createBaoCaoHoatDongYT(baoCao: BaoCaoYTeLaoDongTuyenHuyen): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoHoatDongYTe`,baoCao);
    }
    createBaoCaoYTeLaoDongTuyenHuyen(baoCaoYTeLaoDongTuyenHuyen: BaoCaoYTeLaoDongTuyenHuyen): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoYTeLaoDongTuyenHuyen`,baoCaoYTeLaoDongTuyenHuyen);
    }
    updateBaoCaoYTeLaoDongTuyenHuyen(baoCaoYTeLaoDongTuyenHuyen: BaoCaoYTeLaoDongTuyenHuyen): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateBaoCaoYTeLaoDongTuyenHuyen`,baoCaoYTeLaoDongTuyenHuyen);
    }
    createBaoCaoYTeKiemDichThang(baoCao: BaoCaoKetQuaHoatDongYTKDThang): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoHDYTKDThang`,baoCao);
    }
    createBaoCaoHDYTKD6Thang(baoCao: BaoCaoKetQuaHoatDongYTKD6Thang): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoHDYTKD6Thang`,baoCao);
    }
    createBaoCaoHDYTKDNgay(baoCao: BaoCaoKetQuaHoatDongYTKDNgay): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/CreateBaoCaoHDYTKDNgay`,baoCao);
    }
    createBaoCaoHDYTKDNam(baoCao: BaoCaoKetQuaHoatDongYTKDNam): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoHDYTKDNam`,baoCao);
    }
    createBaoCaoHDYTKDTuan(baoCao: BaoCaoKetQuaHoatDongYTKDTuan): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoHDYTKDTuan`,baoCao);
    }
    createBaoCaoYTeTruongHoc(baoCao: BaoCaoYTeTruongHoc): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoYTeTruongHoc`,baoCao);
    }
    createBaoCaoVSNuocSach(baoCao: BaoCaoVeSinhNuocSach): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoVSNuocSach`,baoCao);
    }
    createBaoCaoThongKeTiemVacxin(baoCao: BaoCaoThongKeTiemVacxin): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoThongKeTiemVacxin`,baoCao);
    }
    createBaoCaoThongKeTinhHinhVacxin(baoCao: BaoCaoTinhHinhSDVacxinVaDCTC): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoThongKeTinhHinhVacxin`,baoCao);
    }
    createBaoCaoSangLocBenh(baoCao: BaoCaoSangLocBenhKLN): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createBaoCaoSangLocBenh`,baoCao);
    }
    getBaoCaoHDYTKDThangById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getBaoCaoHDYTKDThangById/${id}`);
    }
    getListBaoCaoThang(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoThang/${dt1}/${dt2}`);
    }
    getBaoCaoHDYTKDTuanById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getBaoCaoHDYTKDTuanById/${id}`);
    }
    getListBaoCaoTuan(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoTuan/${dt1}/${dt2}`);
    }
    getBaoCaoHDYTKD6ThangById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getBaoCaoHDYTKD6ThangById/${id}`);
    }
    getBaoCaoHDYTKDNamById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getBaoCaoHDYTKDNamById/${id}`);
    }
    getBaoCaoHDYTKNgayById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getBaoCaoHDYTKNgayById/${id}`);
    }
    getListBaoCao6Thang(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCao6Thang/${dt1}/${dt2}`);
    }
    getListBaoCaoNam(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoNam/${dt1}/${dt2}`);
    }
    getListBaoCaoNgay(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoNgay/${dt1}/${dt2}`);
    }
    getListBaoCaoTinhHinhSDVacxinVaDCTC(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoTinhHinhSDVacxinVaDCTC/${dt1}/${dt2}`);
    }
    getBaoCaoTinhHinhSDVacxinVaDCTCById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getBaoCaoTinhHinhSDVacxinVaDCTCById/${id}`);
    }
    exportFileBaoCaoTinhHinhSDVacxin(baoCao: DanhSachBaoCaoThang[]): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/exportFileBaoCaoTinhHinhSDVacxin`,baoCao);
    }
    updateBaoCaoHDYTKDThang(baoCao: BaoCaoKetQuaHoatDongYTKDThang): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateBaoCaoHDYTKDThang`,baoCao);
    }
    updateBaoCaoHDYTKD6Thang(baoCao: BaoCaoKetQuaHoatDongYTKD6Thang): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateBaoCaoHDYTKD6Thang`,baoCao);
    }
    updateBaoCaoHDYTKDNam(baoCao: BaoCaoKetQuaHoatDongYTKDNam): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateBaoCaoHDYTKDNam`,baoCao);
    }
    updateBaoCaoHDYTKDTuan(baoCao: BaoCaoKetQuaHoatDongYTKDTuan): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateBaoCaoHDYTKDTuan`,baoCao);
    }
    updateBaoCaoHDYTKDNgay(baoCao: BaoCaoKetQuaHoatDongYTKDNgay): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateBaoCaoHDYTKDNgay`,baoCao);
    }
    exportFile6Month(baoCao: BaoCaoKetQuaHoatDongYTKD6Thang): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/exportFile6Month`,baoCao);
    }
    exportFileMonth(baoCao: BaoCaoKetQuaHoatDongYTKDThang): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/exportFileMonth`,baoCao);
    }
    exportFileWeek(baoCao: BaoCaoKetQuaHoatDongYTKDTuan): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/exportFileWeek`,baoCao);
    }
    exportFileYear(baoCao: BaoCaoKetQuaHoatDongYTKDNam): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/exportFileYear`,baoCao);
    }
    exportFileDay(baoCao: BaoCaoKetQuaHoatDongYTKDNgay): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/exportFileDay`,baoCao);
    }
    showListWeekDontSend(id): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/showListWeekDontSend/${id}`);
    }
    getWeek(t: ThoiGian): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/getWeek`,t);
    }
    getListBaoCaoSangLoc(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoSangLoc/${dt1}/${dt2}`);
    }
    getBaoCaoSangLocBenhKLNById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getBaoCaoSangLocBenhKLNById/${id}`);
    }
    exportFileSanLoc(baoCao: DanhSachBaoCaoThang[]): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/exportFileSanLoc`,baoCao);
    }
    getListBaoCaoYTeLaoDong(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoYTeLaoDong/${dt1}/${dt2}`);
    }
    getListBaoCaoLaoDongTuyenHuyen(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoLaoDongTuyenHuyen/${dt1}/${dt2}`);
    }
    getListBaoCaoThongKeTiemVacxin(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoThongKeTiemVacxin/${dt1}/${dt2}`);
    }
    getListBaoCaoYTeTruongHoc(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoYTeTruongHoc/${dt1}/${dt2}`);
    }
    getListBaoCaoVeSinhNuocSach(dt1, dt2): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoCaoVeSinhNuocSach/${dt1}/${dt2}`);
    }
}
